import { getRailsClient } from "../client";

const UserEnrollmentsRoute = "/api/internal_api/atlas/v1/current_user/enrollments";

export const getEnrollments = async ({ useToast = true } = {}) => {
  return getRailsClient({ useToast })
    .get(UserEnrollmentsRoute)
    .then(async response => {
      if (response.status === 200) {
        return response.data.currentEnrollments;
      } else {
        return Promise.reject(
          new Error(`getEnrollments: Unable to get enrollments, status code ${response.status}`)
        );
      }
    });
};

const UserEnrollmentRoute = "/api/internal_api/atlas/v1/current_user/role_enrollments/:roleId";

export const doUserEnrollment = async (roleId: number, abandonOtherPaths?: boolean) => {
  const route = UserEnrollmentRoute.replace("/:roleId", "");
  const client = getRailsClient();
  return client.post(route, { id: roleId, abandonOtherPaths }).then(async response => {
    if (response.status === 200) {
      return response.data;
    } else {
      return Promise.reject(
        new Error(`doUserEnrollment: Unable to enroll user, status code ${response.status}`)
      );
    }
  });
};

export const doUserUnenrollment = async (roleId: number) => {
  const route = UserEnrollmentRoute.replace(":roleId", roleId.toString());
  const client = getRailsClient();
  return client.put(route, { operation: "unenroll" }).then(async response => {
    if (response.status === 200) {
      return response.data;
    } else {
      return Promise.reject(
        new Error(`doUserUnenrollment: Unable to unenroll user, status code ${response.status}`)
      );
    }
  });
};
